import { GitBranch } from "lucide-react";

export default function EmptyState({
    title = "Choose a pipeline stage",
    description = "Select a stage from the left to review its actions and configure the workflow.",
}) {
    return (
        <div className="flex h-full items-center justify-center bg-[radial-gradient(circle_at_center,#ffffff_0%,#f6fbff_62%,#f2f8fd_100%)] p-10">

            <div className="max-w-md rounded-3xl border border-dashed border-[#c7dfed] bg-white/90 px-10 py-14 text-center shadow-[0_16px_45px_rgba(31,78,121,0.07)]">

                <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-[#e7f5fc]">

                    <GitBranch
                        size={30}
                        className="text-[#147db5]"
                    />

                </div>

                <h2 className="mt-5 text-xl font-bold tracking-[-0.02em] text-[#102b5c]">
                    {title}
                </h2>

                <p className="mt-2 text-sm leading-6 text-[#7185a3]">
                    {description}
                </p>

            </div>

        </div>
    );
}
